export default __webpack_public_path__ + "static/media/buried-instrusion-detection-system.ba571ca4.jpg";